import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import { fmt } from '../../utils/fmtUtils';

const DatosCamara_Generales = ({ data, title }) => {
  const t = useTranslate();
  return (
    <article className="datosGenerales">
      <div className="subHeader">{title}</div>
      <div className="content">
        <table>
          <tbody>
            <tr>
              <td className="importantData">{t('votantes')}</td>
              <td className="votes">{fmt(data.totales.act.votant)}</td>
              <td className="percent margin">{data.totales.act.pvotant}</td>
            </tr>
            <tr>
              <td rowSpan="2" className="importantData">
                {t('votos') + ' ' + t('validos')}
              </td>
              <td rowSpan="2" className="votes">
                {fmt(data.totales.act.votval)}
              </td>
              <td rowSpan="2" className="percent margin">
                {data.totales.act.pvotval}
              </td>

              <td className="importantData">{t('votosPartidosCandidatos')}</td>
              <td className="votes">{fmt(data.totales.act.votcan)}</td>
              <td className="percent">{data.totales.act.pvotcan}</td>
            </tr>
            <tr>
              <td className="importantData">{t('enBlancoMayuscula')}</td>
              <td className="votes">{fmt(data.totales.act.votbla)}</td>
              <td className="percent">{data.totales.act.pvotbla}</td>
            </tr>
            <tr>
              <td className="importantData">{t('tarjNoMarc')}</td>
              <td className="votes">{fmt(data.totales.act.votnma)}</td>
              <td className="percent margin">{data.totales.act.pvotnma}</td>

              <td className="importantData">{t('votos') + ' ' + t('nulos')}</td>
              <td className="votes">{fmt(data.totales.act.votnul)}</td>
              <td className="percent">{data.totales.act.pvotnul}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  );
};

export default DatosCamara_Generales;
